import { POST_ADMIN_LOGIN, FETCH_USER_PROFILE, SEND_MOBILE_OTP, VERIFY_MOBILE_OTP } from '../../data/APIEndpoints';
import axios from '../AxiosInstance';

const adminLogin = async (loginRequest) => {
    try {
        const response = await axios.post(POST_ADMIN_LOGIN,
            loginRequest
        )
        if(response.status === 200) {
            const result = fetchUserProfile(loginRequest.email);
            return result;
        }
    }
    catch(error) {
        return {
            status: "error",
            message: "Login failed",
            error: error,
        };
    }
}

const fetchUserProfile = async (emailId, phoneNo) => {
    try {
        const response = await axios.get(FETCH_USER_PROFILE,
            {
                params: {
                    email: emailId,
                    phoneNumber: phoneNo
                }
            }
        )
        if(response.status === 200) {
            return { status: "success", data: response.data };
        }
    }
    catch(error) {
        return {
            status: "error",
            message: "Login failed",
            error: error,
        };
    }
}

const sendMobileOTP = async (otpRequest) => {
    try {
        const response = await axios.post(SEND_MOBILE_OTP,
            otpRequest
        )
        if(response.status === 200 || response.status === 201) {
            return { status: "success", data: response.data };
        }
    }
    catch(error) {
        return {
            status: "error",
            message: "OTP Generation failed",
            error: error,
        };
    }
}

const verifyMobileOTP = async (otpValidateRequest) => {
    try {
        const response = await axios.put(VERIFY_MOBILE_OTP,
            otpValidateRequest
        )
        if(response.status === 200 || response.status === 201) {
            const phoneNo = otpValidateRequest.phoneNumber;
            const result = fetchUserProfile(undefined,phoneNo);
            return result;
        }
    }
    catch(error) {
        return {
            status: "error",
            message: "Invalid OTP",
            error: error,
        };
    }
}

const createNormalUserProfile = async (userCreationRequest) => {
    try {
        const response = await axios.post(FETCH_USER_PROFILE,
            userCreationRequest
        )
        if(response.status === 200 || response.status === 201) {
            return { status: "success", data: response.data };
        }
    }
    catch(error) {
        if(error.response.data.message){
            return {
                status: "error",
                message: error.response.data.message,
                error: error,
            };
        } else {
            return {
                status: "error",
                message: "User Creation failed",
                error: error,
            };
        }
    }
}

const loginAPIMethod = {
    adminLogin, sendMobileOTP, verifyMobileOTP, createNormalUserProfile
}

export default loginAPIMethod;